import $ from "jquery";

/*------------------------------------*\
    CALCULATOR
\*------------------------------------*/
class CourseCalculator {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        //this.selectRows();
        this.calculateDelegates();
        this.addToTotal();
        this.resetFields();
    }

    calculateDelegates() {
        let self = this;

        const programme = document.querySelector('#delegate-cost');
        var cost = 0;

        $("#delegate-selector").on("change", function () {

            // Determine whether multi-delegate discount needs to be applied
            if(this.value >= 4) {
                cost = programme.dataset.programmeDelegateCost * this.value;
            } else {
                cost = programme.dataset.programmeCost * this.value;
            }

            // Show updated value on labels
            $('.total')
                .text(cost);
        
            $("#lecture-title")
                .text(cost);

            $("#lectures-selected")
                .text('Full programme for ' + this.value + ' delegate(s)');

            $("input.lectures")
                .prop("value", "Full programme for " + this.value + " delegate(s)");

            $(".custom-lecture-value")
                .prop("value", cost);

            // If no delegates, check cost is zero
            if(this.value > 0) {
                // Automatically check individual lectures
                $("input:checkbox.individual-course")
                    .prop("checked", true)
                    
                $('.individual-course')
                    .prev()
                        .addClass("d-none")

                $('.reset-fields')
                    .removeClass("d-none")

                $("input:checkbox.individual-course")
                    .parent().parent().addClass("highlight");
            } else {
                $("input:checkbox.individual-course")
                        .prop("checked", false)

                $('.individual-course')
                    .prev()
                        .removeClass("d-none btn-primary")
                        .addClass("btn-gold")
                        .text("Add");
                
                $("input:checkbox.individual-course")
                    .parent().parent().removeClass("highlight");
            }
        });
    }

    
    addToTotal() {
        $(function() {
            $('.individual-course').on("click", function() {
                
                var total = 0;
                var selected = [];
                
                $('.individual-course:checked').each(function(index, item) {
                    total += parseFloat(item.value);
                    
                    // Create array of selected lectures to pass through form later
                    selected.push(
                        $(this).data('title')
                    );
                    
                    $(this)
                        .prev()
                            .toggleClass("btn-gold")
                            .toggleClass("btn-primary")
                            .text("Remove")
                            $(this).parent().parent().toggleClass("highlight");

                    $(this)
                        .prev().on("click", function() {
                            $(this).text($(this).text() == 'Remove' ? 'Add' : 'Remove');
                        });
                });
                
                // Update labels & values
                $('.total')
                    .text(total);
                
                $('#payment-modal')
                    .attr('data-lecture-id', total);
                
                $("#lecture-title")
                    .text(total);
                
                $(".custom-lecture-value")
                    .prop("value", total);
                
                $("#lectures-selected")
                    .html(selected.join("<hr class=\"[ line-break line-break--gold ] [ my-1 ]\">"));

                // Update list of selected lectures
                $("input:hidden.lectures")
                    .prop("value", selected);
            });
        });
    }

    selectRows() {
        // Highlight selected lecture rows
        $('.individual-course:checked').each(function() {
            $(this).parent().parent().toggleClass("highlight");
        });   
    }

    resetFields() {
        $('.reset-fields').on("click", function() {
            // Reset delegate selector
            $('#delegate-selector').val(0);

            // Reset all total values
            $('.total')
                .text(0);
    
            $("#lecture-title")
                .text(0);

            $("#lectures-selected")
                .text("No lectures currently selected");

            $(".custom-lecture-value")
                .prop("value", 0);

            $("input.lectures")
                .prop("value", 0);

            // Remove course highlights
            $("input:checkbox.individual-course")
                .prop("checked", false)
            
            $("input:checkbox.individual-course")
                .parent().parent().removeClass("highlight");

            // Present individual course select buttons
            $('.individual-course')
                .prev()
                    .removeClass("d-none btn-primary")
                    .addClass("btn-gold")
                    .text("Add");

            // Finally, hide reset button
            $('.reset-fields')
                .addClass("d-none")
        })
    }
}

export default CourseCalculator;